/* GroundGrabba Cart Compatibility Checker V1
   Rules-based, warning only. Never blocks add to cart or checkout.
   Config (patterns + messages): snippets/cc-checker.liquid
   Per-cart data endpoint:       sections/cc-data.liquid */
(function () {
  'use strict';
  try {
    var cfgEl = document.getElementById('cc-config');
    if (!cfgEl || !window.JSON || !window.MutationObserver) return;
    var CFG = JSON.parse(cfgEl.textContent);
    var PATTERNS = {};
    Object.keys(CFG.patterns || {}).forEach(function (k) {
      PATTERNS[k] = CFG.patterns[k].map(function (p) { return new RegExp(p, 'i'); });
    });
    var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var origFetch = window.fetch ? window.fetch.bind(window) : null;
    var state = { results: null, seq: 0, applying: false };
    var timer = null;
    var obsTimer = null;

    function ssGet(key, fallback) {
      try { var v = window.sessionStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; }
    }
    function ssSet(key, val) {
      try { window.sessionStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
    }

    function track(name, rule, line) {
      try {
        var params = { rule_id: rule.id, level: rule.level, sku: line.sku || '' };
        if (typeof window.gtag === 'function') {
          window.gtag('event', name, params);
        } else {
          window.dataLayer = window.dataLayer || [];
          var ev = { event: name };
          Object.keys(params).forEach(function (k) { ev[k] = params[k]; });
          window.dataLayer.push(ev);
        }
      } catch (e) {}
    }

    /* Classification: variant override (custom.cc_class, comma-separated) wins; else SKU patterns. */
    function classify(item) {
      var set = {};
      var o = (item.o == null ? '' : String(item.o)).trim();
      if (o) {
        o.split(',').forEach(function (c) { c = c.trim(); if (c) set[c] = true; });
        return set;
      }
      var sku = item.sku || '';
      if (!sku) return set;
      Object.keys(PATTERNS).forEach(function (k) {
        for (var i = 0; i < PATTERNS[k].length; i++) {
          if (PATTERNS[k][i].test(sku)) { set[k] = true; break; }
        }
      });
      return set;
    }

    function evaluate(items) {
      var lines = items.map(function (it) {
        return { i: it.i, v: it.v, q: it.q, sku: it.sku || '', x: !!it.x, c: classify(it) };
      });
      function any(cls) { return lines.some(function (l) { return !!l.c[cls]; }); }
      var hasGR14 = any('gr14');
      var hasU = any('gr13u');
      var hasC = any('gr13c');
      var hasGR13 = hasU || hasC;
      var hasJr = any('junior');
      var uses16 = hasU || hasJr;
      var uses19 = hasC || any('lite');
      var out = [];

      lines.forEach(function (L) {
        var w = [];
        var exempt = L.x || !!L.c.gr14ok;
        var r2 = false, r3 = false;

        /* R2 / R3: specific wrong-socket rules (take precedence over R1 for driver lines) */
        if (L.c.tool19 && hasU && !uses19) { r2 = true; w.push({ id: 'R2', anchors: ['gr13u'] }); }
        if (L.c.tool16 && hasC && !uses16) { r3 = true; w.push({ id: 'R3', anchors: ['gr13c'] }); }

        if (hasGR14 && !exempt) {
          /* R1: GR14 accessory mismatch, item-specific suppression */
          var r1 =
            (L.c.tool16 && !uses16 && !r3) ||
            (L.c.tool19 && !uses19 && !r2) ||
            (L.c.hr15 && !hasGR13 && !hasJr) ||
            (L.c.hw13 && !hasGR13) ||
            (L.c.fang && !hasGR13);
          if (r1) w.push({ id: 'R1', anchors: ['gr14'] });
          /* R4: GR14 drill-bit size advisory, never suppressed */
          if (L.c.drill12) w.push({ id: 'R4', anchors: ['gr14'] });
        }

        if (w.length) {
          w.forEach(function (r) {
            var anchorKeys = lines
              .filter(function (a) { return a.i !== L.i && r.anchors.some(function (c) { return a.c[c]; }); })
              .map(function (a) { return a.v + ':' + a.q; })
              .sort();
            r.fp = r.id + '|' + L.v + ':' + L.q + '|' + anchorKeys.join(',');
            r.level = r.id === 'R4' ? 'advisory' : 'mismatch';
          });
          out.push({ line: L, rules: w });
        }
      });
      return out;
    }

    /* Drawer lines: #CartDrawer-Item-N ; cart page lines: #CartItem-N (N = 1-based cart index).
       Variant ID is verified against the line's quantity input where present. */
    function findLineEls(line) {
      var els = [];
      ['CartDrawer-Item-' + line.i, 'CartItem-' + line.i].forEach(function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        var qi = el.querySelector('[data-quantity-variant-id]');
        if (qi && String(qi.getAttribute('data-quantity-variant-id')) !== String(line.v)) return;
        els.push(el);
      });
      return els;
    }

    function buildBox(rules, line) {
      var level = rules.some(function (r) { return r.level === 'mismatch'; }) ? 'mismatch' : 'advisory';
      var box = document.createElement('div');
      box.className = 'cc-warning cc-warning--' + level;
      box.setAttribute('role', 'note');
      rules.forEach(function (r) {
        var p = document.createElement('p');
        p.className = 'cc-warning__msg cc-warning__msg--' + r.level;
        p.textContent = (CFG.messages && CFG.messages[r.id]) || '';
        box.appendChild(p);
      });
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cc-warning__dismiss';
      btn.setAttribute('aria-label', 'Dismiss this notice');
      btn.innerHTML = '&times;';
      btn.addEventListener('click', function (e) {
        try {
          e.preventDefault();
          e.stopPropagation();
          var d = ssGet('cc_dismissed', []);
          rules.forEach(function (r) {
            if (d.indexOf(r.fp) === -1) { d.push(r.fp); track('compatibility_warning_dismissed', r, line); }
          });
          ssSet('cc_dismissed', d);
          render();
        } catch (err) {}
      });
      box.appendChild(btn);
      return box;
    }

    function render() {
      if (!state.results) return;
      state.applying = true;
      try {
        var old = document.querySelectorAll('.cc-warning');
        for (var k = 0; k < old.length; k++) { if (old[k].parentNode) old[k].parentNode.removeChild(old[k]); }
        var dismissed = ssGet('cc_dismissed', []);
        var shown = ssGet('cc_shown', []);
        state.results.forEach(function (res) {
          var rules = res.rules.filter(function (r) { return dismissed.indexOf(r.fp) === -1; });
          if (!rules.length) return;
          var targets = findLineEls(res.line);
          if (!targets.length) return;
          rules.forEach(function (r) {
            if (shown.indexOf(r.fp) === -1) { shown.push(r.fp); track('compatibility_warning_shown', r, res.line); }
          });
          targets.forEach(function (el) {
            var host = el.querySelector('.cart-item__details') || el;
            host.appendChild(buildBox(rules, res.line));
          });
        });
        ssSet('cc_shown', shown);
      } finally {
        state.applying = false;
      }
    }

    function refresh() {
      if (!origFetch) return;
      var mySeq = ++state.seq;
      origFetch(ROOT + '?section_id=cc-data&cc=' + Date.now(), { credentials: 'same-origin' })
        .then(function (r) { return r && r.ok ? r.text() : null; })
        .then(function (html) {
          try {
            if (!html || mySeq !== state.seq) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var s = doc.querySelector('script[data-cc-data]');
            if (!s) return;
            var data = JSON.parse(s.textContent);
            state.results = evaluate(data.items || []);
            render();
          } catch (e) {}
        })
        .catch(function () {});
    }

    function schedule(delay) {
      clearTimeout(timer);
      timer = setTimeout(function () { try { refresh(); } catch (e) {} }, delay == null ? 250 : delay);
    }

    /* Listen to underlying cart calls. Requests/responses pass through untouched. */
    if (origFetch) {
      window.fetch = function () {
        var p = origFetch.apply(window, arguments);
        try {
          var a = arguments[0];
          var url = typeof a === 'string' ? a : (a && a.url) || '';
          if (CART_RE.test(url)) p.then(function () { schedule(); }, function () {});
        } catch (e) {}
        return p;
      };
    }
    try {
      var XO = XMLHttpRequest.prototype.open;
      var XS = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (m, url) {
        try { this.__ccUrl = String(url || ''); } catch (e) {}
        return XO.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        try {
          if (this.__ccUrl && CART_RE.test(this.__ccUrl)) this.addEventListener('loadend', function () { schedule(); });
        } catch (e) {}
        return XS.apply(this, arguments);
      };
    } catch (e) {}

    /* Re-apply warnings when the theme re-renders cart lines (drawer or /cart). */
    var mo = new MutationObserver(function (muts) {
      try {
        if (state.applying || !state.results) return;
        var relevant = muts.some(function (m) {
          for (var i = 0; i < m.addedNodes.length; i++) {
            var n = m.addedNodes[i];
            if (n.nodeType !== 1 || (n.classList && n.classList.contains('cc-warning'))) continue;
            if ((n.classList && n.classList.contains('cart-item')) || (n.querySelector && n.querySelector('.cart-item'))) return true;
          }
          return false;
        });
        if (!relevant) return;
        clearTimeout(obsTimer);
        obsTimer = setTimeout(function () { try { render(); } catch (e) {} }, 60);
      } catch (e) {}
    });
    mo.observe(document.body, { childList: true, subtree: true });

    if (CFG.count > 0) schedule(0);
  } catch (e) {
    /* Failsafe: stop silently; cart behaves as normal. */
  }
})();
